import { attemptDecodeURIComponent } from '@/utils/siteUtils';
import { useEffect, useState } from 'react';
import type { FCl } from 'react-fc';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--size-grid-unit);
    color: var(--cds-color-text);
`;

const StyledBox = styled.p`
    padding: var(--size-grid-half) var(--size-grid-half);
    border: solid 1px;
    font-size: 0.6rem;
    opacity: 0.6;
    text-align: center;
    position: relative;
    word-break: break-all;
`;

export const DebugInfo: FCl = ({ className }) => {
    const [timestamp, setTimestamp] = useState<string>();
    const [url, setUrl] = useState<string>();
    const [userAgent, setUserAgent] = useState<string>();
    const [assetStatus, setAssetStatus] = useState<string>('Assets unchecked');

    // These fields can only be populated client-side.
    useEffect(() => {
        setTimestamp(new Date().toISOString());
        setUrl(attemptDecodeURIComponent(window.location.href));
        setUserAgent(window.navigator.userAgent);
    }, []);

    useEffect(() => {
        setAssetStatus('Assets checking…');
        fetch('https://assets.bnef.com/public/healthcheck.txt')
            .then((response) => setAssetStatus(response.ok ? 'Assets OK' : 'Assets ' + response.status))
            .catch((e) => setAssetStatus('Assets Error: ' + e));
    }, []);

    return (
        <Container className={className}>
            <StyledBox>
                {timestamp}|{url}|{userAgent}|{assetStatus}
            </StyledBox>
        </Container>
    );
};
